import { useCustomerAgentAvailable } from '@/features/whatsapp/hooks/useCustomerAgentAvailable';
import { useConversationsSummary } from './useConversations';
import { CONVERSATIONS_READ_PERMISSION, useConversationsForbidden } from './useConversationsAccess';

/* ==========================================================================
   Item "Atendimento" da navegação (change customer-agent-handoff, D18)

   Aparece com a área do Atendente IA disponível e `conversations.read`, e
   mostra quantas conversas alertadas esperam a equipe (as adiadas pela loja
   fechada não contam). O 403 do resumo (token anterior às claims novas)
   esconde o item, em silêncio, até a renovação do token: a página do
   Atendimento devolveria ao Dashboard sem explicação.
   ========================================================================== */

export interface NavItemGate {
  visible: boolean;
  /** O número ao lado do rótulo; nulo ou 0 não mostra nada. */
  count: number | null;
  /** O que o leitor de tela ouve junto do rótulo ("2 clientes esperando"). */
  countLabel?: string;
}

export function conversationsCountLabel(count: number): string {
  return count === 1 ? '1 cliente esperando' : `${count} clientes esperando`;
}

export function useConversationsNavBadge(): NavItemGate {
  const { available } = useCustomerAgentAvailable(CONVERSATIONS_READ_PERMISSION);
  const forbidden = useConversationsForbidden();
  const summary = useConversationsSummary();
  const count = available && !forbidden ? (summary.data?.awaiting ?? null) : null;
  return {
    visible: available && !forbidden,
    count,
    countLabel: count ? conversationsCountLabel(count) : undefined,
  };
}
